import { createFileRoute, redirect } from '@tanstack/react-router'
import { BillDetailScreen } from '@/features/accounting-bills/bill-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one bill or debit note.
 *
 * The grant guard is `accounting_bill.view`, the same key as the list.
 * Whether the caller may see THIS document is the API's answer, not the
 * browser's: tenancy scoping makes another company's bill a 404, and the
 * screen surfaces that rather than deciding it here.
 */
export const Route = createFileRoute('/_authenticated/accounting/bills/$billId/')({
  // `?pay=true` opens the payment panel on arrival (the purchase order's "Pay bill").
  validateSearch: (search: Record<string, unknown>): { pay?: boolean } =>
    search.pay === true || search.pay === 'true' ? { pay: true } : {},
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bill.view')) {
      throw redirect({ to: '/accounting/bills' })
    }
  },
  component: AccountingBillDetailRoute,
})

function AccountingBillDetailRoute() {
  const { billId } = Route.useParams()
  const { pay } = Route.useSearch()

  return <BillDetailScreen billId={billId} openPay={pay === true} />
}
